class ErrorModel {}

namespace ErrorModel {



  export class BaseError extends Error {

    errorCode: string;
    developerMessage: string; // TODO: Change to debugMessage
    userMessage: string; // TODO: Change to clientMessage, use it as default on the client.

    getErrorCodeName(className: string): string {
      return className.replace(/([A-Z])/g, '_$1').toLowerCase();
    }

    getClassNameWithSpace(className: string): string {
      return className.replace(/([A-Z])/g, ' $1');
    }

  }

  export class InvalidId extends BaseError {

    invalidId: number | string;

    constructor(className: string, id: number | string) {
      super();

      let errorCodeName = this.getErrorCodeName(className);
      let classNameWithSpace = this.getClassNameWithSpace(className);

      this.errorCode = 'invalid' + errorCodeName + '_id';
      this.developerMessage = 'Invalid' + classNameWithSpace + ' Id';
      this.invalidId = id;
    }
  }

  export class InvalidOrder extends BaseError {

    constructor(className: string) {
      super();

      let errorCodeName = this.getErrorCodeName(className);
      let classNameWithSpace = this.getClassNameWithSpace(className);

      this.errorCode = 'invalid_order' + errorCodeName;
      this.developerMessage = 'Invalid ' + classNameWithSpace + ' Order';
    }
  }

  export class ItemAlreadyExists extends BaseError {

    constructor(className: string) {
      super();

      let errorCodeName = this.getErrorCodeName(className);
      let classNameWithSpace = this.getClassNameWithSpace(className);

      this.errorCode = errorCodeName.substring(1) + '_already_exists';
      this.developerMessage = classNameWithSpace.substring(1)  + ' already exists';

    }

  }

  export class EmptyField extends BaseError {

    constructor(className: string) {
      super();

      let errorCodeName = this.getErrorCodeName(className);
      let classNameWithSpace = this.getClassNameWithSpace(className);

      this.errorCode = errorCodeName.substring(1)  + '_field_is_empty';
      this.developerMessage = classNameWithSpace.substring(1)  + ' field should not be empty';

    }

  }

  export class DuplicatedField extends BaseError {

    constructor(className: string, field?: string) {
      super();

      let errorCodeName = this.getErrorCodeName(className);
      let classNameWithSpace = this.getClassNameWithSpace(className);

      this.errorCode = errorCodeName.substring(1)  + `_${field}_is_duplicated`;
      this.developerMessage = classNameWithSpace.substring(1)  + ` ${field} should be unique`;

    }

  }

  export class RequiredField extends BaseError {

    constructor(className: string, fieldName: string) {
      super();

      let errorCodeName = this.getErrorCodeName(className);
      let classNameWithSpace = this.getClassNameWithSpace(className);

      this.errorCode = errorCodeName.substring(1)  + '_required_field';
      this.developerMessage =  fieldName + ' is a required field in ' + classNameWithSpace.substring(1) ;

    }

  }

  export class CreatingError extends BaseError {
    constructor(className: string) {
      super();

      let errorCodeName = this.getErrorCodeName(className);
      let classNameWithSpace = this.getClassNameWithSpace(className);

      this.errorCode = errorCodeName.substring(1)  + '_creating_error';
      this.developerMessage = 'An error occurred while creating the ' + classNameWithSpace.substring(1);

    }
  }

  export class UpdatingError extends BaseError {
    constructor(className: string) {
      super();

      let errorCodeName = this.getErrorCodeName(className);
      let classNameWithSpace = this.getClassNameWithSpace(className);

      this.errorCode = errorCodeName.substring(1)  + '_updating_error';
      this.developerMessage = 'An error occurred while updating the ' + classNameWithSpace.substring(1);

    }
  }

  export class InvalidParameter extends BaseError {
    constructor(className: string, customMsg?: string) {
      super();

      let errorCodeName = this.getErrorCodeName(className);
      let classNameWithSpace = this.getClassNameWithSpace(className);

      this.errorCode = 'invalid_parameter' + errorCodeName;
      this.developerMessage = 'Invalid Parameter:' + classNameWithSpace + '. ' + customMsg;

    }
  }

  export class InactiveEntity extends BaseError {

    constructor(className: string, id: number){
      super();

      let errorCodeName = this.getErrorCodeName(className);
      let classNameWithSpace = this.getClassNameWithSpace(className);

      this.errorCode = 'inactive' + errorCodeName;
      this.developerMessage = 'The' + classNameWithSpace + ' with id: ' + id + ' is no longer active';
    }
  }

  export class IncorrectOldPassword extends BaseError {

    constructor() {
      super();

      this.errorCode = 'incorrect_old_password';
      this.developerMessage = 'The old password entered is not correct.';
    }
  }

  export class CustomMessage extends BaseError {
    constructor( errorCode: string, message: string ) {
      super();

      this.errorCode = errorCode;
      this.developerMessage = message;
      this.userMessage = message;

    }
  }

}

export {ErrorModel};
